import { uniqBy } from 'lodash';
import bankFilterOptions from '../constants/bankFilterOptions';

/**
 * Returns available options of filter user's foreign accounts.
 * Default return contains option 'All'
 *
 * @type {Function}
 * @param {Array<{ bankName: string }>} accounts - List of known user's foreign accounts
 * @returns {Array<{ label: string, value: number, filterFn: function }>}
 * */

export default function (accounts) {
  const filtered = uniqBy(accounts, 'bankName');
  const bankOptions = filtered.map((account, key) => {
    return {
      label: account.bankName,
      value: key + 1,
      filterFn: (accountObject) => accountObject.bankName === account.bankName,
    };
  });

  return [...bankFilterOptions, ...bankOptions];
}
